import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { BrandJson } from "../../../DynamicFormsJson/MastersJSON/brand";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class BrandView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: BrandJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Name ",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Short Name",
                  value:
                    data.data !== null && data.data.shortName !== null
                      ? data.data.shortName
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Sort Order No",
                  value:
                    data.data !== null && data.data.sortOrder !== null
                      ? data.data.sortOrder
                      : "",
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Brand View"}
            fieldMeta={[]}
            apiBaseURL={BrandJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BrandView);
